import ChangePassword from './containers/ChangePassword'

// Sync route definition
export default {
  path: 'change-password',
  component : ChangePassword
}



// WEBPACK FOOTER //
// ./src/routes/ChangePassword/index.js